(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["structure-2-buybox"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('st2-buybox')) {
    customElements.define(
      'st2-buybox',
      class St2Buybox extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-st2-slide]'));
          this.thumbs = Array.from(this.querySelectorAll('[data-st2-thumb]'));
          this.thumbsBox = this.querySelector('[data-st2-thumbs]');
          this.index = 0;
          this.onClick = this.onClick.bind(this);
          this.addEventListener('click', this.onClick);
          this.setShipsDate();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
        }

        onClick(event) {
          const thumb = event.target.closest('[data-st2-thumb]');
          if (thumb && this.contains(thumb)) return this.show(Number(thumb.dataset.st2Thumb));
          if (event.target.closest('[data-st2-prev]')) return this.show(this.index - 1);
          if (event.target.closest('[data-st2-next]')) return this.show(this.index + 1);
        }

        show(next) {
          const total = this.slides.length;
          if (total < 2) return;
          this.index = (next + total) % total;
          this.slides.forEach((slide, i) => {
            const on = i === this.index;
            slide.classList.toggle('is-active', on);
            slide.hidden = !on;
          });
          this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === this.index));
          const active = this.thumbs[this.index];
          if (active && this.thumbsBox) {
            const box = this.thumbsBox;
            const left = active.offsetLeft - box.offsetLeft - (box.clientWidth - active.offsetWidth) / 2;
            box.scrollTo({ left: Math.max(0, left) });
          }
        }

        setShipsDate() {
          const target = this.querySelector('[data-st2-ships]');
          if (!target) return;
          const template = target.getAttribute('data-st2-ships');
          if (!template || template.indexOf('{date}') === -1) return;
          const date = new Date();
          date.setDate(date.getDate() + 1);
          const weekday = date.toLocaleDateString('en-GB', { weekday: 'short' });
          const month = date.toLocaleDateString('en-GB', { month: 'short' });
          const day = date.getDate();
          let suffix = 'th';
          if (day % 10 === 1 && day !== 11) suffix = 'st';
          else if (day % 10 === 2 && day !== 12) suffix = 'nd';
          else if (day % 10 === 3 && day !== 13) suffix = 'rd';
          target.textContent = template.replace('{date}', weekday + ', ' + day + suffix + ' ' + month);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["structure-2-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('st2-faq')) {
    customElements.define(
      'st2-faq',
      class St2Faq extends HTMLElement {
        connectedCallback() {
          this.onToggle = (event) => {
            const opened = event.target;
            if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
            this.querySelectorAll('details[open]').forEach((item) => {
              if (item !== opened) item.open = false;
            });
          };
          this.addEventListener('toggle', this.onToggle, true);
        }

        disconnectedCallback() {
          this.removeEventListener('toggle', this.onToggle, true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["structure-2-mechanism"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('st2-mechanism')) {
    customElements.define(
      'st2-mechanism',
      class St2Mechanism extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-st2-track]');
          if (!this.track) return;
          this.cards = Array.from(this.track.querySelectorAll('[data-st2-card]'));
          this.dots = Array.from(this.querySelectorAll('[data-st2-dot]'));
          if (!this.cards.length) return;

          this.current = 0;
          this.target = null;
          this.dragging = false;
          this.frame = 0;
          this.settleTimer = 0;

          this.onScroll = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = 0;
              this.sync();
            });
          };
          this.onPointerDown = (event) => this.dragStart(event);
          this.onPointerMove = (event) => this.dragMove(event);
          this.onPointerUp = (event) => this.dragEnd(event);
          this.onKeyDown = (event) => {
            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.goTo(this.current + 1);
            } else if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.goTo(this.current - 1);
            }
          };
          this.onBlockSelect = (event) => {
            const index = this.cards.indexOf(event.target);
            if (index > -1) this.goTo(index, true);
          };

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('pointerdown', this.onPointerDown);
          this.track.addEventListener('pointermove', this.onPointerMove);
          this.track.addEventListener('pointerup', this.onPointerUp);
          this.track.addEventListener('pointercancel', this.onPointerUp);
          this.track.addEventListener('keydown', this.onKeyDown);
          this.addEventListener('shopify:block:select', this.onBlockSelect);

          this.dotHandlers = this.dots.map((dot, index) => {
            const handler = () => this.goTo(index);
            dot.addEventListener('click', handler);
            return handler;
          });

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => {
              if (this.dragging) return;
              this.track.scrollLeft = this.cards[this.current].offsetLeft;
            });
            this.resizeObserver.observe(this.track);
          }
        }

        disconnectedCallback() {
          if (!this.track) return;
          this.track.removeEventListener('scroll', this.onScroll);
          this.track.removeEventListener('pointerdown', this.onPointerDown);
          this.track.removeEventListener('pointermove', this.onPointerMove);
          this.track.removeEventListener('pointerup', this.onPointerUp);
          this.track.removeEventListener('pointercancel', this.onPointerUp);
          this.track.removeEventListener('keydown', this.onKeyDown);
          this.removeEventListener('shopify:block:select', this.onBlockSelect);
          this.dots.forEach((dot, index) => dot.removeEventListener('click', this.dotHandlers[index]));
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          clearTimeout(this.settleTimer);
        }

        nearest() {
          const left = this.track.scrollLeft;
          let best = 0;
          let bestDistance = Infinity;
          this.cards.forEach((card, index) => {
            const distance = Math.abs(card.offsetLeft - left);
            if (distance < bestDistance) {
              bestDistance = distance;
              best = index;
            }
          });
          return best;
        }

        sync() {
          if (this.target !== null) {
            const arrived = Math.abs(this.cards[this.target].offsetLeft - this.track.scrollLeft) < 2;
            if (!arrived) return;
            this.target = null;
          }
          this.setActive(this.nearest());
        }

        setActive(index) {
          this.current = index;
          this.dots.forEach((dot, i) => {
            const active = i === index;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-current', active ? 'true' : 'false');
          });
        }

        goTo(index, instant) {
          const next = Math.max(0, Math.min(this.cards.length - 1, index));
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.target = next;
          this.setActive(next);
          this.track.scrollTo({
            left: this.cards[next].offsetLeft,
            behavior: instant || reduce ? 'auto' : 'smooth'
          });
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => {
            this.target = null;
            this.setActive(this.nearest());
          }, 700);
        }

        dragStart(event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.dragging = true;
          this.startX = event.clientX;
          this.startScroll = this.track.scrollLeft;
          this.startIndex = this.current;
          this.target = null;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }

        dragMove(event) {
          if (!this.dragging) return;
          this.track.scrollLeft = this.startScroll - (event.clientX - this.startX);
        }

        dragEnd(event) {
          if (!this.dragging) return;
          this.dragging = false;
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          const distance = event.clientX - this.startX;
          let index = this.nearest();
          if (distance < -50) index = Math.max(index, this.startIndex + 1);
          else if (distance > 50) index = Math.min(index, this.startIndex - 1);
          this.track.classList.remove('is-dragging');
          this.goTo(index);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["structure-2-sale-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('st2-sale-banner')) {
    customElements.define(
      'st2-sale-banner',
      class St2SaleBanner extends HTMLElement {
        connectedCallback() {
          const minutes = parseFloat(this.dataset.minutes);
          this.remaining = Math.max(0, Math.round((isNaN(minutes) ? 0 : minutes) * 60));
          this.hoursEl = this.querySelector('[data-st2-unit="hours"]');
          this.minutesEl = this.querySelector('[data-st2-unit="minutes"]');
          this.secondsEl = this.querySelector('[data-st2-unit="seconds"]');
          if (!this.hoursEl || !this.minutesEl || !this.secondsEl) return;
          this.finished = false;
          this.stop();
          this.tick();
          if (!this.finished) {
            this.timer = setInterval(() => this.tick(), 1000);
          }
        }

        disconnectedCallback() {
          this.stop();
        }

        stop() {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }

        pad(value) {
          return String(value).padStart(2, '0');
        }

        tick() {
          const total = this.remaining;
          this.hoursEl.textContent = this.pad(Math.floor(total / 3600));
          this.minutesEl.textContent = this.pad(Math.floor((total % 3600) / 60));
          this.secondsEl.textContent = this.pad(total % 60);
          if (total > 0) {
            this.remaining = total - 1;
          } else {
            this.finished = true;
            this.stop();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["structure-2-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('st2-sticky-cta')) {
    customElements.define(
      'st2-sticky-cta',
      class St2StickyCta extends HTMLElement {
        connectedCallback() {
          this.bar = this.querySelector('.st2-sticky-cta__bar');
          if (!this.bar || !('IntersectionObserver' in window)) return;
          if (window.Shopify && Shopify.designMode) return;

          this.stuck = false;
          this.targetVisible = false;
          this.slotBelow = false;

          let target = null;
          const selector = this.dataset.watch;
          if (selector) {
            try {
              target = document.querySelector(selector);
            } catch (error) {
              target = null;
            }
          }

          this.slotObserver = new IntersectionObserver(
            (entries) => {
              const entry = entries[entries.length - 1];
              this.slotBelow = !!entry.rootBounds && entry.boundingClientRect.bottom > entry.rootBounds.bottom;
              this.update();
            },
            { threshold: [0, 1] }
          );
          this.slotObserver.observe(this);

          if (target) {
            this.targetObserver = new IntersectionObserver((entries) => {
              this.targetVisible = entries[entries.length - 1].isIntersecting;
              this.update();
            });
            this.targetObserver.observe(target);
          }

          if ('ResizeObserver' in window) {
            this.sizeObserver = new ResizeObserver(() => {
              if (this.stuck) this.style.minHeight = this.bar.offsetHeight + 'px';
            });
            this.sizeObserver.observe(this.bar);
          }
        }

        disconnectedCallback() {
          if (this.slotObserver) this.slotObserver.disconnect();
          if (this.targetObserver) this.targetObserver.disconnect();
          if (this.sizeObserver) this.sizeObserver.disconnect();
          this.stuck = false;
          this.style.minHeight = '';
          this.classList.remove('st2-sticky-cta--stuck');
        }

        update() {
          const stuck = !this.targetVisible && this.slotBelow;
          if (stuck === this.stuck) return;
          this.stuck = stuck;
          this.style.minHeight = stuck ? this.bar.offsetHeight + 'px' : '';
          this.classList.toggle('st2-sticky-cta--stuck', stuck);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["structure-2-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('st2-timeline')) {
    customElements.define(
      'st2-timeline',
      class St2Timeline extends HTMLElement {
        connectedCallback() {
          const items = Array.from(this.querySelectorAll('[data-st2-reveal]'));
          if (!this.classList.contains('st2-tl--anim') || !items.length) return;

          if (!('IntersectionObserver' in window) || Shopify.designMode) {
            items.forEach((item) => this.reveal(item, 0));
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const item = entry.target;
                const row = item.closest('.st2-tl__row');
                const siblings = row ? Array.from(row.querySelectorAll('[data-st2-reveal]')) : [item];
                this.reveal(item, siblings.indexOf(item) * 90);
                this.observer.unobserve(item);
              });
            },
            { threshold: 0.3 }
          );
          items.forEach((item) => this.observer.observe(item));
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        reveal(item, delay) {
          setTimeout(() => {
            item.classList.add('is-visible');
            if (item.dataset.st2Reveal === 'center') item.classList.add('is-pulsing');
          }, delay);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
